<script setup>
import { useLayout } from '@/layout/composables/layout';
import { watch, ref } from 'vue';
import { useRoute } from 'vue-router';

const { layoutState, isRightHistoryActive } = useLayout();
const route = useRoute();
const items = ref([]);

watch(isRightHistoryActive, (newVal) => {
    if (route.meta.breadcrumb) {
        items.value = [];
        const bc = route.meta.breadcrumb[0];
        for (let pro in bc) {
            items.value.push({ label: bc[pro] });
        }
    }
});
</script>

<template>
    <Sidebar class="custom-sidebar" v-model:visible="layoutState.rightHistoryActive.value" position="right" :showCloseIcon="false" :baseZIndex="1000" blockScroll>
        <div class="p-3">
            <div class="flex flex-column mb-5">
                <h6 class="pb-2 mb-2 border-bottom-1 surface-border">
                    <template v-for="(item, index) in items" :key="index">
                        <span class="mr-2"> {{ $t('shared.historyOf') }}</span>
                        <span> {{ $t(item.label) }}</span>
                        <span v-if="index !== items.length - 1">
                            <i class="pi pi-angle-right"></i>
                        </span>
                    </template>
                </h6>
                <div class="flex pt-2">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">New Sale</span>
                        <span class="mb-2 line-height-3">Richard Jones has purchased a blue t-shirt for $79.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="" />
                            <small>Emmy Adams, 21.40</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Withdrawal Initiated</span>
                        <span class="mb-2 line-height-3">Your request for withdrawal of $2500 has been initiated.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-2" />
                            <small>Emily Walter, 21.40</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Question Received</span>
                        <span class="mb-2 line-height-3">Jane Davis has posted a new question about your product.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-3" />
                            <small>Jane Davis, 21.45</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Withdrawal Initiated</span>
                        <span class="mb-2 line-height-3">Your request for withdrawal of $2500 has been initiated.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-2" />
                            <small>Emily Walter, 21.40</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Question Received</span>
                        <span class="mb-2 line-height-3">Jane Davis has posted a new question about your product.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-3" />
                            <small>Jane Davis, 21.45</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Withdrawal Initiated</span>
                        <span class="mb-2 line-height-3">Your request for withdrawal of $2500 has been initiated.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-2" />
                            <small>Emily Walter, 21.40</small>
                        </span>
                    </div>
                </div>
                <div class="flex pt-3">
                    <i class="pi pi-images align-self-start p-2 border-1 border-transparent border-circle mr-2" style="background-color: rgba(0, 0, 0, 0.12)"></i>
                    <div class="flex flex-column">
                        <span class="font-bold mb-1">Question Received final</span>
                        <span class="mb-2 line-height-3">Jane Davis has posted a new question about your product.</span>
                        <span class="flex align-items-center">
                            <img class="mr-2" src="/layout/images/avatar/amyelsner.png" alt="avatar-3" />
                            <small>Jane Davis, 21.45 final</small>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </Sidebar>
</template>
